import React from 'react';
import { useBedrockRegistration } from 'store';
import Link from 'components/Link';
import { InteractiveTextLink } from 'components/InteractiveTextLink';
import { SCREENS } from 'lib/loginFormConstants';
import { AppleLoginButton } from './AppleLogin/index';
import { GoogleLoginButton } from './GoogleLogin/index';

import styles from './styles.module.scss';

/**
 * Displays Apple and Google login buttons
 * @param {object} props - The component props.
 * @param {string} props.pageView - The page type.
 * @param {string} props.currentScreen - current screen.
 * @returns {React.ReactElement} The rendered component.
 */
const SocialLogin = ({
  pageView, currentScreen, hasResetPassword = false,
}) => {
  const setScreen = useBedrockRegistration((state) => state.setScreen);
  const track = useBedrockRegistration((state) => state.track);

  return (
    <>
      <div className={styles.separator}>
        <span>or</span>
      </div>
      <div className={styles.linksContainer}>
        <div data-testid="social-login" className={styles.socialLogin}>
          <GoogleLoginButton
            pageView={pageView}
            currentScreen={currentScreen}
          />
          <AppleLoginButton
            pageView={pageView}
            currentScreen={currentScreen}
          />
        </div>

        {hasResetPassword ? (
          <div className={styles.resetPassword}>
            <span>Trouble logging in?&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <Link
              to="https://profile.id.nbcuni.com/forgot-password"
              target="_blank"
              className={styles.buttonLink}
            >
              Reset your password
            </Link>
          </div>
        ) : null}

        <InteractiveTextLink
          onClick={() => {
            track({
              action: 'SignUp:Submit',
              method: 'PoweredByNBCUButton:Click',
            });
            setScreen(SCREENS.NBCU_PROFILE);
          }}
          isBelowButton
          dataTestid="nbcu-profile-button"
        >
            Powered by NBCUniversal Profile
        </InteractiveTextLink>
      </div>
    </>
  );
};

export { SocialLogin };
